import { RenterBenefit } from "providers/auth/types";
import CreditMonitoring from "../assets/credit_monitoring.svg?react";
import IdentityTheftProtection from "../assets/identity_theft_protection.svg?react";
import RentReporting from "../assets/rent_reporting.svg?react";
import { Card } from "common/Card";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";

const benefitDataMap = {
  [RenterBenefit.CREDIT_MONITORING]: {
    title: "Credit monitoring",
    description: "Track changes in your credit score over time",
    Icon: CreditMonitoring
  },
  [RenterBenefit.IDENTITY_THEFT_PROTECTION]: {
    title: "Identity theft protection",
    description:
      "Protect against identity theft with a $1M insurance, monitoring, and resolution services",
    Icon: IdentityTheftProtection
  },
  [RenterBenefit.RENT_REPORTING]: {
    title: "Rent reporting",
    description:
      "Report your current and past rent payments to Experian, Equifax and TransUnion",
    Icon: RentReporting
  }
};

export const BenefitCard = ({ benefit }: { benefit: RenterBenefit }) => {
  const Icon = benefitDataMap[benefit].Icon;
  return (
    <Card
      className="max-w-[342px] w-full h-[316px] shrink-0"
      linkTo={`/${benefit}/onboarding/intro`}
    >
      <div className="px-5 py-4 flex flex-col h-[calc(100%-72px)]">
        <h2 className="text-xl font-bold text-content-1000 mb-2">
          {benefitDataMap[benefit].title}
        </h2>

        <p className="text-sm text-content-500 font-medium">
          {benefitDataMap[benefit].description}
        </p>

        <Icon className="mt-auto text-primary-500" />
      </div>

      <div className="px-5 py-4 border-t border-alpha-40">
        <Button
          className="w-full"
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SM}
        >
          Activate
        </Button>
      </div>
    </Card>
  );
};
